import {metadata} from '../../libraries/metadata/metadata.js';
metadata.register("logicadBidAdapter", {"disclosures":{},"components":[{"componentType":"bidder","componentName":"logicad","disclosureURL":null}]})